import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./mediaComponent.module.scss";
import dynamic from "next/dynamic";
import { eventBus } from "@kunduz/utility-common";
import { CommonComponentProps } from "../../config";
import classNames from "classnames";

const WistiaPlayer = dynamic(
  () => import("@wistia/wistia-player-react").then((mod) => mod.WistiaPlayer),
  {
    ssr: false,
    loading() {
      return (
        <div style={{ width: "100%", aspectRatio: "16/9" }}>Loading...</div>
      );
    },
  },
);

export const MediaComponent = (props: MediaComponentProps) => {
  const videoRef = useRef(null);
  const {
    bgImage,
    file,
    wistiaId,
    options: { sizeDesktop, sizeMobile, sizeTablet },
  } = props;

  useEffect(() => {
    if (!eventBus) return;

    function playVideo(id) {
      if (id !== props.mediaComponentId.toString()) {
        return;
      }

      if (wistiaId) {
        const player: any = document.getElementById("wistia-video");

        player?.play();

        return;
      }

      if (videoRef?.current?.play) {
        videoRef.current.play();
      }
    }

    eventBus.on("play-video", playVideo);

    return () => {
      eventBus.off("play-video", playVideo);
    };
  }, [props.mediaComponentId, wistiaId]);

  const onClick = () => {};

  const renderVideo = () => {
    if (wistiaId) {
      return (
        <WistiaPlayer
          id="wistia-video"
          ref={videoRef}
          mediaId={wistiaId}
          aspect={16 / 9}
          controlsVisibleOnLoad
          volumeControl
          onPlay={onClick}
          className={styles.video}
          key={`${wistiaId}-${props.mediaComponentId}`}
        />
      );
    }

    if (file) {
      return (
        <video
          ref={videoRef}
          controls
          className={styles.video}
          onClick={onClick}
          key={`${file}-${props.mediaComponentId}`}
        >
          <source src={file} type="video/mp4" />
        </video>
      );
    }
  };

  return (
    <div
      className={classNames(
        styles.container,
        styles[`${sizeMobile}Mobile`],
        styles[`${sizeTablet}Tablet`],
        styles[`${sizeDesktop}Desktop`],
      )}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {renderVideo()}
    </div>
  );
};

export interface MediaComponentProps extends CommonComponentProps {
  bgImage: string;
  file?: string;
  name?: string;
  wistiaId?: string;
  mediaComponentId?: number;
}
